import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-05281cec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

import { Skeletor } from 'vue-skeletor';
import { Icon } from '../../Atoms';
import { IconPositionType } from '../../types/IconPositionType';
import 'vue-skeletor/dist/vue-skeletor.css';


export default /*#__PURE__*/_defineComponent({
  __name: 'IconText',
  props: {
    iconName: {},
    iconSm: { type: Boolean },
    iconLg: { type: Boolean },
    iconMd: { type: Boolean },
    text: {},
    iconPos: {},
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{
      iconRight: _ctx.iconPos === _unref(IconPositionType).PosRight,
      iconBottom: _ctx.iconPos === _unref(IconPositionType).PosBottom
    }, "iconText"])
  }, [
    _createVNode(_unref(Icon), {
      "icon-name": _ctx.iconName,
      md: _ctx.iconMd,
      sm: _ctx.iconSm,
      lg: _ctx.iconLg
    }, null, 8, ["icon-name", "md", "sm", "lg"]),
    (_ctx.text && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.text), 1))
      : (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_unref(Skeletor), { key: 1 }))
        : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})